import axiosInstance from '@/services/axiosInstance'

async function addTraspasoEmpresas (payload, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve()
    })
  } else {
    const req = {
      url: '/api/usuarios/traspasarempresasusuarios',
      method: 'PUT',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: payload,
      params,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { addTraspasoEmpresas }
